import { render, staticRenderFns } from "./Zivali.vue?vue&type=template&id=7de06a21&"
import script from "./Zivali.vue?vue&type=script&lang=js&"
export * from "./Zivali.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports